var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-pack-component"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{staticClass:"list-service-pack",attrs:{"md":24}},_vm._l((_vm.listPacks),function(item){return _c('div',{key:item.id,on:{"click":function($event){return _vm.chooseServicePack(item)}}},[_c('div',{class:{
            'list-service-pack--item margin-20': true,
            clickSP: item.id === _vm.selectedServicePack.id,
          },attrs:{"id":item.id}},[_c('div',{staticClass:"bang-gia__services-block gold"},[_c('div',{staticClass:"icon-circle"},[_c('i',{staticClass:"fa-solid fa-circle-check"})]),_c('div',{staticClass:"premium-block-wrapper"},[_c('p',{staticClass:"bang-gia__services-price"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.formatCurrency(item.gia_niem_yet)))])]),_c('span',[_vm._v("\n                  /\n                  "+_vm._s(item.chu_ky_goi.loai === "quy"
                      ? "qúy"
                      : item.chu_ky_goi.loai === "nam"
                      ? "năm"
                      : item.chu_ky_goi.loai === "thang"
                      ? "tháng"
                      : "")+"\n                ")])]),_c('p',{staticClass:"bang-gia__services-name text-uppercase"},[_vm._v("\n                "+_vm._s(item.ten)+"\n              ")]),_c('ul',{staticClass:"bang-gia__services-feature"},[_c('li',[_c('b',[_vm._v(_vm._s(_vm.returnDisplayInformation(
                      item.danh_sach_chuc_nang,
                      "THANH_VIEN"
                    ).gia_tri_hien_thi))]),_c('span',[_vm._v(_vm._s(_vm.returnDisplayInformation(
                      item.danh_sach_chuc_nang,
                      "THANH_VIEN"
                    ).ten))])]),_c('li',[_c('b',[_vm._v(_vm._s(_vm.returnDisplayInformation(
                      item.danh_sach_chuc_nang,
                      "NGUOI_QUAN_LY"
                    ).gia_tri_hien_thi))]),_c('span',[_vm._v(_vm._s(_vm.returnDisplayInformation(
                      item.danh_sach_chuc_nang,
                      "NGUOI_QUAN_LY"
                    ).ten))])]),_c('li',[_c('b',[_vm._v(_vm._s(_vm.returnDisplayInformation(
                      item.danh_sach_chuc_nang,
                      "DUNG_LUONG"
                    ).gia_tri_hien_thi))]),_c('span',[_vm._v(_vm._s(_vm.returnDisplayInformation(
                      item.danh_sach_chuc_nang,
                      "DUNG_LUONG"
                    ).ten))])])])])])])])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }